/** Initial helper reference */
const helper = {}


helper.getActiveActions = (schedule, actionList) => {
  const {validationStatus} = schedule
  return actionList.filter((action) => {
    return action.visibleStatuses.includes(validationStatus)
  }).sort((action, nextAction) => {
    if (action.primaryStatuses.includes(validationStatus)) {
      return -1
    } else {
      return nextAction.primaryStatuses.includes(validationStatus) ? 1 : 0
    }
  })
}

export const getActiveActions = helper.getActiveActions

/** export default helper obj */
export default helper
